import React, { useState } from 'react';
import {
  Alert, Box, Button, Paper, Stack, TextField, Typography,
} from '@mui/material';
import { request, useOperations } from './OperationsProvider';
import brand from '../shell/brand';

const BrandingPanel = () => {
  const { data, refresh } = useOperations();
  const [name, setName] = useState(data.branding?.displayName || brand.name);
  const [logo, setLogo] = useState(data.branding?.logoDataUrl || '');
  const [error, setError] = useState(null); const [saved, setSaved] = useState(false); const [pending, setPending] = useState(false);
  const upload = (event) => { const file = event.target.files[0]; if (!file) return; setError(null); setSaved(false); if (!['image/png', 'image/jpeg'].includes(file.type) || file.size > 256 * 1024) { setError('Use a PNG/JPEG up to 256 KB.'); return; } const reader = new FileReader(); reader.onload = () => setLogo(reader.result); reader.onerror = () => setError('Could not read this file.'); reader.readAsDataURL(file); };
  const save = async (event) => { event.preventDefault(); setPending(true); setError(null); setSaved(false); try { await request('/api/operations/branding', 'PUT', { displayName: name, logoDataUrl: logo }); await refresh(); setSaved(true); } catch (e) { setError(e.message); } finally { setPending(false); } };
  return (
    <Paper component="form" onSubmit={save} variant="outlined" sx={{ p: 3, maxWidth: 650 }}>
      <Stack gap={2}>
        <Typography variant="h6">Workspace branding</Typography>
        <Typography color="text.secondary">Your logo appears in this tenant workspace and in PDF and Excel reports.</Typography>
        {error && <Alert severity="error">{error}</Alert>}
        {saved && <Alert severity="success">Branding saved.</Alert>}
        <TextField label="Display name" value={name} onChange={(e) => setName(e.target.value)} required />
        {logo && <Box component="img" src={logo} alt="Logo preview" sx={{ maxWidth: 240, height: 100, objectFit: 'contain', alignSelf: 'start' }} />}
        <Button component="label" variant="outlined">
          Choose logo
          <input hidden type="file" accept="image/png,image/jpeg" onChange={upload} />
        </Button>
        <Typography variant="caption">PNG or JPEG · Up to 256 KB · Maximum 2048 × 2048 pixels</Typography>
        <Stack direction="row" gap={2}>
          <Button type="submit" variant="contained" disabled={pending}>Save branding</Button>
          <Button onClick={() => setLogo('')}>Use default logo</Button>
        </Stack>
      </Stack>
    </Paper>
  );
};
export default BrandingPanel;
